import {Link, useLocation} from "react-router-dom";
import mobileLogo from "../assets/thrombiocolourlogocopy4.webp";

export default function Footer() {
  const location = useLocation().pathname;

    return (
        <div className={`max-w-dvw z-10 ${location === "/" ? "max-md:bg-black" : ""}`}>
      <div className="page-width flex justify-center pt-40 pb-20 md:py-16">
        <Link to="/" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}><img src={mobileLogo} alt="ThromBio Logo" className="max-lg:max-h-[66px]" /></Link>
      </div>
    </div>
  );
}
